/*
 * @Description  : 文库管理接口
 * @Author       : zcc
 * @Date         : 2025-04-24 17:21:55
 * @LastEditors  : zcc
 * @LastEditTime : 2025-04-24 15:48:16
 * @FilePath     : \ngs_platform_manage_admin\src\api\modules\library\library-management\index.js
 */
import request from "../../../request.js";

//  文库管理 - 列表  分页查询 ---- 朱新宇
export const selectDocPage = function (data) {
  return request({
    url: "/docManage/selectDocPage",
    method: "post",
    data
  });
};

//  文库管理 - 保存 ---- 朱新宇
export const saveDoc = function (data) {
  return request({
    url: "/docManage/saveDoc",
    method: "post",
    data
  });
};

//  文库管理 - 更改状态 ---- 朱新宇
export const updateDocStatus = function (data) {
  return request({
    url: "/docManage/updateDocStatus",
    method: "post",
    data
  });
};

//  文库-上传附件 ---- 朱新宇
export const saveDocFile = function (data) {
  return request({
    url: "/docManage/saveDocFile",
    method: "post",
    data,
	requestConfig: {
		timeOut: 6000000
	}
  });
};

//  文库-获取附件列表 ---- 朱新宇
export const getDocFiles = function (data) {
  return request({
    url: "/docManage/getDocFiles",
    method: "post",
    data
  });
};

//  文库-修改附件状态 ---- 朱新宇
export const updateDocFileStatus = function (data) {
  return request({
    url: "/docManage/updateDocFileStatus",
    method: "post",
    data
  });
};

//  AI文件解析 ---- 汪杰
export const parseFile = function (data) {
  return request({
    url: "/aiSearchInfo/parseFile",
    method: "post",
    data
  });
};

//  从向量库中删除指定文件 ---- 汪杰
export const deleteById = function (data) {
  return request({
    url: "/aiSearchInfo/deleteById",
    method: "post",
    data
  });
};
